import { SupplementalMaterialsStatus } from '../../../common/typings/DocumentViewer/enums';
import { ViewInLibraryStatus } from '../typing/enums';
import { IOrderViewerViewModel } from '../typing/orderViewerViewModel';
import { action, makeObservable, observable } from 'mobx';

export interface IOrderViewerStore {
	readonly viewModel: IOrderViewerViewModel;
	readonly supplementalMaterialsStatus: SupplementalMaterialsStatus;
	readonly viewInLibraryStatus: ViewInLibraryStatus;
	readonly libraryDocumentId: number;
	setIframeLoading: (loading: boolean) => void;
	setSupplementalMaterialsStatus: (status: SupplementalMaterialsStatus) => void;
	setViewInLibraryStatus: (status: ViewInLibraryStatus) => void;
	setLibraryDocumentId: (docId: number) => void;
}

export default class OrderViewerStore implements IOrderViewerStore {
	public viewModel: IOrderViewerViewModel | null = null;
	public isLoading: boolean;
	public supplementalMaterialsStatus: SupplementalMaterialsStatus;
	public viewInLibraryStatus: ViewInLibraryStatus;
	public libraryDocumentId: number;

	constructor(viewModel: IOrderViewerViewModel) {
		this.viewModel = viewModel;
		this.isLoading = false;
		this.supplementalMaterialsStatus =
			viewModel.headerModel?.supplementalMaterialViewModel.supplementalMaterialsStatus;
		this.viewInLibraryStatus = viewModel.viewInLibraryStatus;
		this.libraryDocumentId = viewModel.documentModel?.documentId;

		makeObservable(this, {
			setIframeLoading: action.bound,
			isLoading: observable.struct,
			supplementalMaterialsStatus: observable.struct,
			viewInLibraryStatus: observable.struct,
			libraryDocumentId: observable.struct,
			setSupplementalMaterialsStatus: action.bound,
			setViewInLibraryStatus: action.bound,
			setLibraryDocumentId: action.bound
		});
	}

	public setIframeLoading(loading: boolean): void {
		this.isLoading = loading;
	}

	public setSupplementalMaterialsStatus(status: SupplementalMaterialsStatus) {
		this.supplementalMaterialsStatus = status;
	}

	public setViewInLibraryStatus(status: ViewInLibraryStatus) {
		this.viewInLibraryStatus = status;
	}

	public setLibraryDocumentId(docId: number) {
		this.libraryDocumentId = docId;
	}
}
